import { FaGithub, FaLinkedinIn } from 'react-icons/fa';
import cn from 'classnames';

import TwitterSVG from '@/svg/icons/twitter.svg';
import GlobeSVG from '@/svg/icons/globe.svg';

type SocialMediaLinksProps = {
  linkedinUrl?: string;
  twitterHandle?: string;
  websiteUrl?: string;
  gitHub?: string;
  className?: string;
};

export default function SocialMediaLinks({
  linkedinUrl,
  twitterHandle,
  websiteUrl,
  gitHub,
  className,
}: SocialMediaLinksProps) {
  return (
    <div
      className={cn(`flex items-center space-x-6 text-light-haiti`, className)}
    >
      {twitterHandle && (
        <a
          href={`https://twitter.com/${twitterHandle}`}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="fill-current hover:text-haiti transition-colors"
        >
          <span className="sr-only">Twitter</span>
          <TwitterSVG className="w-5 h-5" />
        </a>
      )}

      {linkedinUrl && (
        <a
          href={linkedinUrl}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="fill-current hover:text-haiti transition-colors"
        >
          <span className="sr-only">LinkedIn</span>
          <FaLinkedinIn className="w-5 h-5" />
        </a>
      )}

      {gitHub && (
        <a
          href={gitHub}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="fill-current hover:text-haiti transition-colors"
        >
          <span className="sr-only">GitHub</span>
          <FaGithub className="w-5 h-5" />
        </a>
      )}

      {websiteUrl && (
        <a
          href={websiteUrl}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="fill-current hover:text-haiti transition-colors"
        >
          <span className="sr-only">Website</span>
          <GlobeSVG className="w-5 h-5" />
        </a>
      )}
    </div>
  );
}
